import React from 'react';
import { flushSync } from 'react-dom';
import ToggleButtonGroup from '@mui/material/ToggleButtonGroup';
import ToggleButton from '@mui/material/ToggleButton';
import { MdOutlineFitScreen, MdOutlineImage } from 'react-icons/md';
import { useDispatch } from 'react-redux';
import { requestFit, clearSelection } from '../../features/networkSlice';
import { exportSvg, downloadText } from '../../lib/network/exportSvg';

export default function View() {
  const dispatch = useDispatch();

  const handleExport = async () => {
    // render without selection highlights before capturing the drawing
    flushSync(() => dispatch(clearSelection()));
    const svg = await exportSvg(document.getElementById('network-svg'));
    if (svg) downloadText(svg, 'model.svg', 'image/svg+xml');
  };

  return (
    <ToggleButtonGroup size="small" sx={{ ml: 1 }}>
      <ToggleButton value="" title="Fit to view [f]" onClick={() => dispatch(requestFit())}>
        <MdOutlineFitScreen size="1.5em" />
      </ToggleButton>
      <ToggleButton value="" title="Export as SVG" onClick={handleExport}>
        <MdOutlineImage size="1.5em" />
      </ToggleButton>
    </ToggleButtonGroup>
  );
}
